import Message from './Message';

// Mensagens de histórico não precisam mostrar o status
export default class HistoryMessage extends Message {
  constructor(message) {
    super(message);

    // this.status = null
  }
}
